import { useMemo, useCallback } from 'react';
import { useAppThunkDispatch } from 'state/store';
import { useSelector } from 'react-redux';
import {
  getSelectedProjectOwners,
  getProjectOwnersList,
  selectSelectedProjectOwners,
  selectSelectedProjectOwnerIds,
  selectProjectOwnersOptions,
  updateFilters,
  selectCanGetMoreProjectOwners,
  resetState,
} from 'state/ProjectOwners/projectOwnersSlice';
import { FilterParams } from 'types/store/projectOwners';

const useProjectOwners = () => {
  const dispatch = useAppThunkDispatch();
  const selectedProjectOwners = useSelector(selectSelectedProjectOwners);
  const selectedProjectOwnerIds = useSelector(selectSelectedProjectOwnerIds);
  const availableProjectOwners = useSelector(selectProjectOwnersOptions);
  const canGetMoreProjectOwners = useSelector(selectCanGetMoreProjectOwners);

  const fetchSelectedProjectOwners = useCallback(
    (selected: string[]) => {
      dispatch(getSelectedProjectOwners({ selected }));
    },
    [dispatch]
  );

  const fetchAvailableProjectOwners = useCallback(() => {
    dispatch(getProjectOwnersList({}));
  }, [dispatch]);

  const handleFilterProjectOwners = useCallback(
    (filter: FilterParams) => {
      dispatch(updateFilters(filter));
      dispatch(getProjectOwnersList({}));
    },
    [dispatch]
  );

  const loadMoreProjectOwners = useCallback(async () => {
    await dispatch(getProjectOwnersList({}));
  }, [dispatch]);

  const resetProjectOwnersState = useCallback(() => {
    dispatch(resetState());
  }, [dispatch]);

  return useMemo(
    () => ({
      fetchSelectedProjectOwners,
      fetchAvailableProjectOwners,
      selectedProjectOwners,
      selectedProjectOwnerIds,
      availableProjectOwners,
      handleFilterProjectOwners,
      loadMoreProjectOwners,
      canGetMoreProjectOwners,
      resetProjectOwnersState,
    }),
    [
      fetchSelectedProjectOwners,
      selectedProjectOwnerIds,
      selectedProjectOwners,
      fetchAvailableProjectOwners,
      handleFilterProjectOwners,
      availableProjectOwners,
      loadMoreProjectOwners,
      canGetMoreProjectOwners,
      resetProjectOwnersState,
    ]
  );
};

export default useProjectOwners;
